import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../i18n/LanguageContext";
import { ArrowUpRight } from "@phosphor-icons/react";

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer
      className="relative bg-[#0a0a0a] text-white mt-32"
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-14">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="gm-eyebrow text-white/50">Global Marketing</div>
            <h3 className="font-display text-3xl md:text-4xl mt-4 leading-tight">
              {t.footer.tagline}
            </h3>
            <p className="text-white/60 mt-6 max-w-md text-sm leading-relaxed">
              Praha · Bratislava
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="gm-eyebrow text-white/50">{t.nav.pillars}</div>
            <ul className="mt-4 space-y-2 text-sm">
              <li><Link to="/merchandising-services" className="hover:text-[#0A4DFF] transition-colors">{t.pillars.merchandising.title}</Link></li>
              <li><Link to="/instore-data" className="hover:text-[#0A4DFF] transition-colors">{t.pillars.instore.title}</Link></li>
              <li><Link to="/shelfmasters" className="hover:text-[#0A4DFF] transition-colors">{t.pillars.shelfmasters.title}</Link></li>
              <li><Link to="/retail-digitalisation" className="hover:text-[#0A4DFF] transition-colors">{t.pillars.digital.title}</Link></li>
              <li><Link to="/retail-consulting" className="hover:text-[#0A4DFF] transition-colors">{t.pillars.consulting.title}</Link></li>
              <li><Link to="/pos" className="hover:text-[#0A4DFF] transition-colors">{t.pillars.pos.title}</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="gm-eyebrow text-white/50">{t.nav.contact}</div>
            <a
              href="mailto:info@globalmarketing.cz"
              className="block mt-4 font-display text-lg md:text-xl break-all hover:text-[#0A4DFF] transition-colors"
              data-testid="footer-email-link"
            >
              info@globalmarketing.cz <ArrowUpRight className="inline" size={16} />
            </a>
            <a href="tel:+420602111108" className="block text-sm text-white/60 mt-3 hover:text-[#0A4DFF] transition-colors">+420 602 111 108</a>
          </div>
        </div>

        <div className="border-t border-white/10 mt-16 pt-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-white/40">
          <span>{t.footer.copy}</span>
          <span className="font-mono tracking-wider">v.2026.1</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
